(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-pairing-builder-runtime"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (customElements.get('ab-pairing-builder')) return;
  const strings = JSON.parse(document.querySelector('[data-ab-pairing-i18n]').textContent);
  const t = key => typeof strings[key] === 'string' ? strings[key] : key;
  const stamp = () => typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  const propertyKey = name => /^properties\[(.+)\]$/.exec(name)?.[1];
  const isComplete = (items, expected, batchId) => {
    const own = items.filter(item => item.properties?._ab_pairing_id === batchId);
    return own.length === expected.length && expected.every((item, index) => {
      const found = own.find(line => line.properties?._ab_pairing_component === String(index + 1));
      return found && String(found.variant_id || found.id) === String(item.id) && found.quantity === item.quantity &&
        Object.entries(item.properties).every(([key, value]) => found.properties?.[key] === value);
    });
  };
  class PairingBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialogs = new Map();
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'ja', { style: 'currency', currency: this.dataset.currency || 'JPY' });
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-ab-pairing-open]');
        if (open) { event.preventDefault(); this.open(open); return; }
        const dialog = event.target.closest('dialog');
        if (!dialog) return;
        if (event.target.closest('[data-ab-pairing-close]')) { event.preventDefault(); this.close(dialog); }
        if (event.target.closest('[data-ab-pairing-add]')) { event.preventDefault(); this.add(dialog); }
      });
      this.addEventListener('submit', event => {
        if (!event.target.matches('[data-ab-pairing-form]')) return;
        event.preventDefault();
        this.add(event.target.closest('dialog'));
      });
      this.addEventListener('change', event => {
        const dialog = event.target.closest('dialog');
        if (dialog && event.target.matches('[data-ab-pairing-variant], [data-ab-pairing-quantity]')) this.refresh(dialog);
      });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-ab-pairing-quantity]')) this.refresh(event.target.closest('dialog'));
      });
    }
    getState(dialog) { return this.dialogs.get(dialog); }
    format(value) { return this.money.format(value / 100); }
    async open(opener) {
      const dialog = document.getElementById(opener.dataset.abPairingOpen);
      if (!dialog || !this.contains(dialog)) return;
      let state = this.getState(dialog);
      if (!state) {
        dialog.querySelector('[data-ab-pairing-mount]').append(dialog.querySelector('[data-ab-pairing-template]').content.cloneNode(true));
        state = { busy: false, locked: false, ready: false, forms: Array.from(dialog.querySelectorAll('[data-ab-pairing-form]')), products: new Map() };
        this.dialogs.set(dialog, state);
        try {
          state.forms.forEach(form => state.products.set(form, JSON.parse(form.querySelector('[data-ab-pairing-variant-data]').textContent)));
        } catch (error) { state.locked = true; state.errorKey = 'load_error'; }
        dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(dialog); });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = state.bodyOverflow || '';
          state.opener?.focus({ preventScroll: true });
        });
      }
      state.opener = opener;
      if (!dialog.open) {
        state.bodyOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      if (state.locked) { this.refresh(dialog); if (state.errorKey) this.message(dialog, t(state.errorKey)); return; }
      this.refresh(dialog);
      if (!state.ready) {
        const editors = dialog.querySelectorAll('ab-personalizer');
        if (editors.length) {
          try {
            let timer;
            await Promise.race([
              customElements.whenDefined('ab-personalizer'),
              new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('not-ready')), 8000); })
            ]).finally(() => clearTimeout(timer));
            if (!Array.from(editors).every(editor => editor.ready)) throw new Error('not-ready');
          } catch (error) { state.locked = true; this.message(dialog, t('load_error')); return; }
        }
        state.ready = true;
        this.refresh(dialog);
      }
    }
    close(dialog) {
      if (this.getState(dialog)?.busy) return;
      dialog.close();
    }
    selected(form, state) {
      const id = form.querySelector('[name="id"]')?.value;
      return state.products.get(form)?.variants.find(variant => String(variant.id) === id);
    }
    quantity(dialog) { return Number(dialog.querySelector('[data-ab-pairing-quantity]').value); }
    needsImage(form, state) {
      return state.products.get(form)?.requiresImage === true || Boolean(form.querySelector('ab-personalizer')?.schema?.fields?.some(field => field.kind === 'file'));
    }
    quantityAllowed(variant, quantity) {
      const rule = variant?.quantityRule || {};
      const min = Number(rule.min || 1);
      const increment = Number(rule.increment || 1);
      return Number.isSafeInteger(quantity) && quantity > 0 && quantity >= min && (quantity - min) % increment === 0 && (rule.max == null || quantity <= Number(rule.max));
    }
    refresh(dialog) {
      const state = this.getState(dialog);
      if (!state) return;
      let subtotal = 0;
      let available = state.forms.length >= 2 && state.forms.length <= 4;
      let imageRequired = false;
      const quantity = this.quantity(dialog);
      state.forms.forEach(form => {
        const variant = this.selected(form, state);
        if (!variant || !variant.available || state.products.get(form)?.requiresSellingPlan) available = false;
        if (this.needsImage(form, state)) { imageRequired = true; available = false; }
        if (variant) subtotal += variant.price;
        form.querySelector('[data-ab-pairing-component-price]').textContent = variant ? this.format(variant.price) : t('unavailable');
        const input = form.querySelector('[name="quantity"]');
        if (input) input.value = String(quantity);
      });
      dialog.querySelector('[data-ab-pairing-total]').textContent = this.format(subtotal * (Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1));
      const button = dialog.querySelector('[data-ab-pairing-add]');
      button.disabled = state.busy || state.locked || !state.ready || !available;
      button.textContent = state.busy ? t('adding') : t('add_to_cart');
      if (!available && state.ready && !state.busy) this.message(dialog, t(imageRequired ? 'file_error' : 'unavailable'));
    }
    message(dialog, message, cartLink = false) {
      const status = dialog.querySelector('[data-ab-pairing-status]');
      status.textContent = message;
      status.hidden = !message;
      dialog.querySelector('[data-ab-pairing-cart-link]').hidden = !cartLink;
    }
    validate(dialog) {
      const state = this.getState(dialog);
      const quantity = this.quantity(dialog);
      const quantityInput = dialog.querySelector('[data-ab-pairing-quantity]');
      let valid = state.ready && !state.locked;
      let quantityValid = true;
      state.forms.forEach(form => {
        const variant = this.selected(form, state);
        if (!variant?.available || state.products.get(form)?.requiresSellingPlan) valid = false;
        if (this.needsImage(form, state)) valid = false;
        if (!this.quantityAllowed(variant, quantity)) quantityValid = false;
        const editor = form.querySelector('ab-personalizer');
        if (editor && (typeof window.ABPersonalizerUI?.validateProductForm !== 'function' || !window.ABPersonalizerUI.validateProductForm(form))) valid = false;
      });
      quantityInput.setCustomValidity(quantityValid ? '' : t('quantity_error'));
      quantityInput.setAttribute('aria-invalid', quantityValid ? 'false' : 'true');
      if (!quantityValid) { valid = false; quantityInput.reportValidity(); }
      if (!valid) {
        this.message(dialog, quantityValid ? t('validation_error') : t('quantity_error'));
        const first = dialog.querySelector('[aria-invalid="true"]');
        first?.focus({ preventScroll: true });
        first?.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
      return valid;
    }
    payload(dialog, batchId) {
      const state = this.getState(dialog);
      const quantity = this.quantity(dialog);
      return state.forms.map((form, index) => {
        const properties = Object.create(null);
        for (const [name, value] of new FormData(form)) {
          const key = propertyKey(name);
          if (!key) continue;
          if (value instanceof File) {
            if (value.size > 0) throw new Error('file');
            continue;
          }
          properties[key] = value;
        }
        properties[t('set_property')] = dialog.dataset.abPairingTitle;
        properties._ab_pairing_id = batchId;
        properties._ab_pairing_component = String(index + 1);
        return { id: Number(form.querySelector('[name="id"]').value), quantity, properties };
      });
    }
    url(path) {
      const root = this.dataset.rootUrl || '/';
      return new URL(root.replace(/\/?$/, '/') + path, location.origin).href;
    }
    async request(url, init = {}) {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...init });
      const data = await response.json();
      return { ok: response.ok, data };
    }
    async freshProducts(dialog) {
      const state = this.getState(dialog);
      const urls = [...new Set(state.forms.map(form => form.dataset.productUrl))];
      const snapshots = new Map(await Promise.all(urls.map(async path => {
        const url = new URL(path, location.origin);
        if (url.origin !== location.origin) throw new Error('product-url');
        url.pathname = url.pathname.replace(/\.js$/, '') + '.js';
        url.search = '';
        const response = await this.request(url.href, { signal: AbortSignal.timeout(15000) });
        if (!response.ok || !Array.isArray(response.data.variants)) throw new Error('product-data');
        return [path, response.data];
      })));
      let changed = false;
      state.forms.forEach(form => {
        const data = state.products.get(form);
        const latest = snapshots.get(form.dataset.productUrl);
        if (String(latest.id) !== form.dataset.productId) throw new Error('product-mismatch');
        data.requiresSellingPlan = latest.requires_selling_plan === true;
        const tags = Array.isArray(latest.tags) ? latest.tags : typeof latest.tags === 'string' ? latest.tags.split(',').map(tag => tag.trim()) : [];
        if (tags.includes('image_upload')) data.requiresImage = true;
        data.variants.forEach(variant => {
          const current = latest.variants.find(item => item.id === variant.id);
          variant.available = Boolean(current?.available);
          if (current && Number.isSafeInteger(current.price)) {
            if (variant.price !== current.price && String(variant.id) === form.querySelector('[name="id"]').value) changed = true;
            variant.price = current.price;
          }
          const option = form.querySelector('select[name="id"] option[value="' + variant.id + '"]');
          if (option) {
            option.disabled = !variant.available;
            option.textContent = variant.title + ' — ' + this.format(variant.price) + (variant.available ? '' : ' · ' + t('sold_out'));
          }
        });
      });
      this.refresh(dialog);
      return changed;
    }
    freeze(dialog, freeze) {
      const state = this.getState(dialog);
      if (freeze) {
        state.controls = Array.from(dialog.querySelectorAll('input, select, textarea, [data-ab-pairing-close]')).map(control => [control, control.disabled]);
        state.controls.forEach(([control]) => { control.disabled = true; });
      } else {
        state.controls?.forEach(([control, disabled]) => { control.disabled = disabled; });
        state.controls = null;
      }
      dialog.setAttribute('aria-busy', freeze ? 'true' : 'false');
    }
    async reconcile(dialog, items, batchId) {
      const cart = await this.request(this.url('cart.js'), { signal: AbortSignal.timeout(15000) });
      if (!cart.ok || !Array.isArray(cart.data.items)) throw new Error('cart-read');
      if (isComplete(cart.data.items, items, batchId)) return { complete: true, cart: cart.data };
      const own = cart.data.items.filter(item => item.properties?._ab_pairing_id === batchId);
      if (!own.length) return { complete: false, clean: true };
      const updates = Object.fromEntries(own.map(item => [item.key, 0]));
      const cleaned = await this.request(this.url('cart/update.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }), signal: AbortSignal.timeout(20000) });
      if (!cleaned.ok || !Array.isArray(cleaned.data.items) || cleaned.data.items.some(item => item.properties?._ab_pairing_id === batchId)) throw new Error('cart-cleanup');
      return { complete: false, clean: true };
    }
    finish(dialog, response) {
      const state = this.getState(dialog);
      state.locked = true;
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-pairing-builder', cartData: response });
      } catch (error) {}
      this.message(dialog, t('added'), true);
      location.assign(this.dataset.cartUrl);
    }
    async add(dialog) {
      const state = this.getState(dialog);
      if (!state || state.busy || state.locked || !state.ready) return;
      this.message(dialog, '');
      this.refresh(dialog);
      if (!this.validate(dialog)) return;
      state.busy = true;
      this.refresh(dialog);
      let sent = false;
      let responseReceived = false;
      try {
        const priceChanged = await this.freshProducts(dialog);
        if (priceChanged) { this.message(dialog, t('price_changed')); return; }
        if (!this.validate(dialog)) return;
        const batchId = stamp();
        const items = this.payload(dialog, batchId);
        this.freeze(dialog, true);
        sent = true;
        const result = await this.request(this.dataset.addUrl.replace(/\.js$/, '') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }), signal: AbortSignal.timeout(30000)
        });
        responseReceived = true;
        if (result.ok && Array.isArray(result.data.items) && isComplete(result.data.items, items, batchId)) { this.finish(dialog, result.data); return; }
        const status = await this.reconcile(dialog, items, batchId);
        if (status.complete) { this.finish(dialog, status.cart); return; }
        this.message(dialog, t('add_failed'));
      } catch (error) {
        if (sent) {
          state.locked = true;
          this.message(dialog, t(responseReceived ? 'partial_error' : 'uncertain_error'), true);
        } else this.message(dialog, t(error.message === 'file' ? 'file_error' : 'network_error'));
      } finally {
        state.busy = false;
        this.freeze(dialog, false);
        this.refresh(dialog);
      }
    }
    disconnectedCallback() {
      this.dialogs?.forEach((state, dialog) => {
        if (dialog.open) document.body.style.overflow = state.bodyOverflow || '';
      });
    }
  }
  customElements.define('ab-pairing-builder', PairingBuilder);
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ab-personalizer-runtime"] && !Shopify.designMode) return;
  try {
    (function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.ABPersonalizerCore = factory();
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var MAX_TEXT_LENGTH = 200;
  var MAX_FILE_BYTES = 20 * 1024 * 1024;
  var owns = function (object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  };

  function text(id, key, placeholder) {
    return {
      id: id,
      key: key,
      label: id,
      kind: 'text',
      required: true,
      // This is the new HTML input limit, not a verified manufacturing limit.
      maxLength: MAX_TEXT_LENGTH,
      placeholder: placeholder || ''
    };
  }

  function font(key) {
    return {
      id: 'font', key: key, label: 'font', kind: 'select',
      required: true, maxLength: MAX_TEXT_LENGTH,
      options: [
        { value: 'ゴシック体', label: 'font_gothic' },
        { value: '筆記体', label: 'font_script' }
      ]
    };
  }

  function threadColor(palette) {
    return {
      id: 'thread_color', key: 'Choose A Color', label: 'thread_color',
      kind: 'select', required: true, maxLength: MAX_TEXT_LENGTH,
      options: palette
    };
  }

  var bibColors = [
    { value: 'ブルー', label: 'blue', color: '#2993cc' },
    { value: 'ピンク', label: 'pink', color: '#ef3dff' },
    { value: 'グレー', label: 'gray', color: '#bdb9b9' },
    { value: 'ライトピンク', label: 'light_pink', color: '#e398d4' },
    { value: 'ゴールド', label: 'gold', color: '#f0eb48' }
  ];
  // Zepto stores these color names, including leading spaces, in legacy carts.
  // The HEX values are only for displaying the separately verified swatches.
  var gauzeColors = [
    { value: 'Gray', label: 'gray', color: '#8b8a91' },
    { value: ' Blue', label: 'blue', color: '#1ac3ed' },
    { value: '  Pink', label: 'pink', color: '#fc79b0' },
    { value: '  Light Pink', label: 'light_pink', color: '#f7afe8' }
  ];

  function fabricFields(placeholder, palette) {
    return [
      text('name', '名前入力を入力してください', placeholder),
      font('字体を選択してください'),
      threadColor(palette)
    ];
  }

  function nameplateFields() {
    return [
      text('name', '名前（ローマ字、漢字、ひらがな）', 'Himari 陽葵 ひまり'),
      text('birth_date', '生年月日', '2024.12.20')
    ];
  }

  function mirrorPlateFields() {
    return [
      // The trailing space is part of the existing order-property key.
      text('kanji', '名前(漢字) ', '名前【例:空】'),
      text('birth_date', '生年月日', '生年月日')
    ];
  }

  function schema(id, fields, unverified) {
    var result = { id: id, fields: fields, preview: fields[0].kind !== 'file' };
    if (unverified) result.unverified = true;
    return result;
  }

  // Legacy property keys are retained exactly; metallic textarea settings were verified.
  var products = {
    '5523034407070': schema('5523034407070', [text('name', 'Field 1', 'TEXT')]),
    '5523096109214': schema('5523096109214', fabricFields('例:HIMARI', bibColors)),
    '6722373386398': schema('6722373386398', fabricFields('例:ICHITO', gauzeColors)),
    '6722954395806': schema('6722954395806', fabricFields('例:都澄  ICHITO', gauzeColors)),
    '7066680164510': schema('7066680164510', [Object.assign(text('name', 'Field 1', 'TEXT'), {multiline:true, maxLines:3, maxLength:600})]),
    '7066682917022': schema('7066682917022', [text('name', 'Field 1', 'TEXT')]),
    '7272751366302': schema('7272751366302', [
      text('name', '名前入力を入力してください', '（※全ての食器に刻印されます）')
    ]),
    '7965875241118': schema('7965875241118', [
      text('kanji', '①名前(漢字) ', '空'),
      text('roman', '②ローマ字名前', 'Sora'),
      text('birth_date', '③生年月日', '2023.05.09'),
      text('birth_weight', '④体重', '2989g'),
      text('birth_height', '⑤身長', '46cm'),
      text('birth_time', '⑥時間', '20:43')
    ]),
    '8193671299230': schema('8193671299230', nameplateFields()),
    '8193678770334': schema('8193678770334', nameplateFields()),
    '8241007788190': schema('8241007788190', [
      text('name', 'お名前を入力して下さい', '名前（ローマ字、漢字、ひらがな）'),
      text('birth_date', '生年月日', '2024.12.20')
    ]),
    '8264989311134': schema('8264989311134', [{
      id: 'image', key: 'アップロード画像', label: 'image', kind: 'file',
      required: true, maxLength: null
    }]),
    '8355726950558': schema('8355726950558', [
      text('name', '名前を入力してください', '例:Himari'),
      font('字体を選択してください')
    ]),
    '8355727376542': schema('8355727376542', [
      text('name', '名前入力を入力してください', '例:Himari'),
      font('字体を選択')
    ]),
    '8645699633310': schema('8645699633310', mirrorPlateFields()),
    '8645758681246': schema('8645758681246', mirrorPlateFields()),
    '8645758779550': schema('8645758779550', [
      text('kanji', '名前(漢字) ', '空'),
      text('kana', 'ひらがな　名前', 'そら'),
      text('birth_date', '生年月日', '例:令和元年11月28日'),
      text('birth_weight', '体重', '例:2989'),
      text('birth_height', '身長', '例:46.5')
    ])
  };
  var productIds = Object.freeze(["8871358791838", "8871358824606", "8871358922910", "8871358988446", "8871362003102", "8871362101406"]);

  var previewFonts = Object.freeze({
    'OpenSans-Bold': 'ABLegacyOpenSans',
    'Arial': 'ABLegacyArial',
    'Koruri-extrabold': 'ABGothic, sans-serif',
    'Homemade-one': 'ABScript, cursive',
    'Ipaexm': null,
    'Janetta-rossie': null
  });
  var legacyPreviewDefaults = {
    '5523034407070': { 'Field 1': { font:'OpenSans-Bold', color:'#48484a' } },
    '7066680164510': { 'Field 1': { font:'OpenSans-Bold', color:'#48484a' } },
    '7066682917022': { 'Field 1': { font:'OpenSans-Bold', color:'#48484a' } },
    '7272751366302': { '名前入力を入力してください': { font:'OpenSans-Bold', color:'#48484a' } },
    '7965875241118': {
      '①名前(漢字) ': { font:'OpenSans-Bold', color:'#48484a' },
      '②ローマ字名前': { font:'OpenSans-Bold', color:'#48484a' },
      '③生年月日': { font:'OpenSans-Bold', color:'#48484a' },
      '④体重': { font:'OpenSans-Bold', color:'#48484a' },
      '⑤身長': { font:'OpenSans-Bold', color:'#48484a' },
      '⑥時間': { font:'OpenSans-Bold', color:'#48484a' }
    },
    '8193671299230': {
      '名前（ローマ字、漢字、ひらがな）': { font:'Arial', color:'#160de9' },
      '生年月日': { font:'Arial', color:'#160de9' }
    },
    '8193678770334': {
      '名前（ローマ字、漢字、ひらがな）': { font:'Arial', color:'#160de9' },
      '生年月日': { font:'Arial', color:'#160de9' }
    },
    '8241007788190': {
      'お名前を入力して下さい': { font:'Arial', color:'#160de9' },
      '生年月日': { font:'Arial', color:'#160de9' }
    },
    '8645699633310': {
      '名前(漢字) ': { font:'OpenSans-Bold', color:'#48484a', textTransform:'uppercase' },
      '生年月日': { font:'OpenSans-Bold', color:'#48484a' }
    },
    '8645758681246': {
      '名前(漢字) ': { font:'OpenSans-Bold', color:'#48484a', textTransform:'uppercase' },
      '生年月日': { font:'OpenSans-Bold', color:'#48484a' }
    },
    '8355726950558': { '名前を入力してください': { color:'#160de9' } },
    '8355727376542': { '名前入力を入力してください': { color:'#160de9' } }
  };

  // Exact product/property-key patches from the verified legacy field evidence.
  var legacyFieldPatches = {
  "5523034407070": {
    "Field 1": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "5523096109214": {
    "名前入力を入力してください": {
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "6722373386398": {
    "名前入力を入力してください": {
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "6722954395806": {
    "名前入力を入力してください": {
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "7066680164510": {
    "Field 1": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200,
      "textTransform": "none"
    }
  },
  "7066682917022": {
    "Field 1": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "7272751366302": {
    "名前入力を入力してください": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 3,
      "maxLength": 600,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "7965875241118": {
    "①名前(漢字) ": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "②ローマ字名前": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "③生年月日": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "④体重": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "⑤身長": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "⑥時間": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "8193671299230": {
    "名前（ローマ字、漢字、ひらがな）": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    },
    "生年月日": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    }
  },
  "8193678770334": {
    "名前（ローマ字、漢字、ひらがな）": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    },
    "生年月日": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    }
  },
  "8241007788190": {
    "お名前を入力して下さい": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    },
    "生年月日": {
      "previewFont": "Arial",
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    }
  },
  "8355726950558": {
    "名前を入力してください": {
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    }
  },
  "8355727376542": {
    "名前入力を入力してください": {
      "previewColor": "#160de9",
      "multiline": false,
      "maxLength": 200,
      "textTransform": "none",
      "lengthUnit": "utf16"
    }
  },
  "8645699633310": {
    "名前(漢字) ": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "生年月日": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "8645758681246": {
    "名前(漢字) ": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "生年月日": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  },
  "8645758779550": {
    "名前(漢字) ": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "ひらがな　名前": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "none",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "生年月日": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "体重": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    },
    "身長": {
      "previewFont": "OpenSans-Bold",
      "previewColor": "#48484a",
      "multiline": true,
      "maxLines": 4,
      "maxLength": 800,
      "textTransform": "uppercase",
      "lengthUnit": "grapheme",
      "maxCharsPerLine": 200
    }
  }
};
  Object.keys(legacyFieldPatches).forEach(function (id) {
    products[id].fields.forEach(function (field) {
      var patch = legacyFieldPatches[id][field.key];
      if (!patch) return;
      Object.assign(field, patch);
      if (!legacyPreviewDefaults[id]) legacyPreviewDefaults[id] = {};
      var style = legacyPreviewDefaults[id][field.key] || {};
      if (patch.previewFont) style.font = patch.previewFont;
      if (patch.previewColor) style.color = patch.previewColor;
      if (patch.textTransform) style.textTransform = patch.textTransform;
      legacyPreviewDefaults[id][field.key] = style;
    });
  });

  function freeze(value) {
    Object.keys(value).forEach(function (key) {
      if (value[key] && typeof value[key] === 'object') freeze(value[key]);
    });
    return Object.freeze(value);
  }
  freeze(products);
  freeze(legacyPreviewDefaults);
  freeze(legacyFieldPatches);

  function productId(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    var match = /^(?:gid:\/\/shopify\/Product\/)?([0-9]+)$/.exec(String(value));
    return match ? match[1] : null;
  }

  function invalidSchema(id) {
    return Object.freeze({ id: productId(id), fields: [], invalid: true, preview: false });
  }

  function getSchema(id, configuration) {
    var normalized = productId(id);
    if (!normalized) return null;
    if (configuration === null || configuration === undefined) {
      if (productIds.includes(normalized)) return invalidSchema(normalized);
      var fallback = owns(products, normalized) ? products[normalized] : null;
      return fallback && !fallback.unverified ? fallback : null;
    }
    function invalid() { return invalidSchema(normalized); }
    if (!configuration || typeof configuration !== 'object' || Array.isArray(configuration) ||
        configuration.version !== 1 || typeof configuration.enabled !== 'boolean') return invalid();
    if (!configuration.enabled) return null;
    if (!Array.isArray(configuration.fields) || configuration.fields.length < 1 || configuration.fields.length > 20 ||
        (owns(configuration, 'preview') && typeof configuration.preview !== 'boolean')) return invalid();
    var fieldIds = new Set();
    var propertyKeys = new Set();
    var fields = [];
    function validText(value) {
      return typeof value === 'string' && !isBlank(value) && value.length <= MAX_TEXT_LENGTH;
    }
    for (var field of configuration.fields) {
      if (!field || typeof field !== 'object' || Array.isArray(field) ||
          typeof field.id !== 'string' || !/^[a-zA-Z][a-zA-Z0-9_-]{0,63}$/.test(field.id) ||
          ['__proto__', 'constructor', 'prototype'].includes(field.id) || fieldIds.has(field.id) ||
          !validText(field.key) || /[\[\]\u0000-\u001f\u007f]/.test(field.key) || propertyKeys.has(field.key) ||
          !validText(field.label) || !['text', 'select', 'file'].includes(field.kind) ||
          typeof field.required !== 'boolean') return invalid();
      if ((owns(field, 'multiline') && typeof field.multiline !== 'boolean') ||
          (field.kind !== 'text' && (field.multiline === true || owns(field, 'maxLines')))) return invalid();
      if ((owns(field, 'previewFont') && (field.kind !== 'text' || typeof field.previewFont !== 'string' || !owns(previewFonts, field.previewFont))) ||
          (owns(field, 'previewColor') && (field.kind !== 'text' || typeof field.previewColor !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(field.previewColor))) ||
          (owns(field, 'textTransform') && (field.kind !== 'text' || !['none','uppercase'].includes(field.textTransform)))) return invalid();
      if ((owns(field, 'lengthUnit') && (field.kind !== 'text' || !['utf16','grapheme'].includes(field.lengthUnit))) ||
          (owns(field, 'maxCharsPerLine') && (field.kind !== 'text' || field.multiline !== true || field.lengthUnit !== 'grapheme' || !Number.isInteger(field.maxCharsPerLine) || field.maxCharsPerLine < 1 || field.maxCharsPerLine > MAX_TEXT_LENGTH))) return invalid();
      var result = { id:field.id, key:field.key, label:field.label, kind:field.kind, required:field.required };
      if (field.kind === 'text') {
        var multiline = field.multiline === true;
        var maxLines = multiline ? field.maxLines : 1;
        if (!Number.isInteger(maxLines) || maxLines < 1 || maxLines > 10 ||
            (!multiline && owns(field, 'maxLines') && field.maxLines !== 1) ||
            !Number.isInteger(field.maxLength) || field.maxLength < 1 || field.maxLength > MAX_TEXT_LENGTH * maxLines ||
            (owns(field, 'placeholder') && (typeof field.placeholder !== 'string' || field.placeholder.length > MAX_TEXT_LENGTH))) return invalid();
        result.maxLength = field.maxLength;
        result.placeholder = field.placeholder || '';
        if (multiline) { result.multiline = true; result.maxLines = maxLines; }
        if (owns(field, 'previewFont')) result.previewFont = field.previewFont;
        if (owns(field, 'previewColor')) result.previewColor = field.previewColor;
        if (owns(field, 'textTransform')) result.textTransform = field.textTransform;
        if (owns(field, 'lengthUnit')) result.lengthUnit = field.lengthUnit;
        if (owns(field, 'maxCharsPerLine')) result.maxCharsPerLine = field.maxCharsPerLine;
      } else if (field.kind === 'select') {
        if (!Array.isArray(field.options) || field.options.length < 1 || field.options.length > 50) return invalid();
        var optionValues = new Set();
        result.maxLength = MAX_TEXT_LENGTH;
        result.options = [];
        for (var option of field.options) {
          if (!option || typeof option !== 'object' || !validText(option.value) || !validText(option.label) ||
              optionValues.has(option.value) || (owns(option, 'color') && (typeof option.color !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(option.color))) ||
              (owns(option, 'font') && (typeof option.font !== 'string' || !owns(previewFonts, option.font)))) return invalid();
          var cleanOption = { value:option.value, label:option.label };
          if (owns(option, 'color')) cleanOption.color = option.color;
          if (owns(option, 'font')) cleanOption.font = option.font;
          result.options.push(cleanOption);
          optionValues.add(option.value);
        }
      } else { result.maxLength = null; }
      fieldIds.add(field.id);
      propertyKeys.add(field.key);
      fields.push(result);
    }
    return freeze({ id:normalized, fields:fields, preview:configuration.preview !== false && fields.some(function (field) { return field.kind === 'text'; }), managed:true });
  }

  function previewStyle(schemaValue, field, values) {
    var input = values && typeof values === 'object' ? values : {};
    var defaults = owns(legacyPreviewDefaults, schemaValue.id) ? legacyPreviewDefaults[schemaValue.id] : null;
    var legacy = defaults && owns(defaults, field.key) ? defaults[field.key] : {};
    var fontField = schemaValue.fields.find(function (item) { return item.id === 'font' && item.kind === 'select'; });
    var fontOption = fontField && fontField.options.find(function (option) { return owns(input, fontField.id) && option.value === input[fontField.id]; });
    var selectedFont = fontOption && (fontOption.font || (fontOption.value === '筆記体' ? 'Homemade-one' : fontOption.value === 'ゴシック体' ? 'Koruri-extrabold' : null));
    var colorField = schemaValue.fields.find(function (item) { return item.id === 'thread_color' && item.kind === 'select'; });
    var colorOption = colorField && colorField.options.find(function (option) { return owns(input, colorField.id) && option.value === input[colorField.id]; });
    var font = field.previewFont || selectedFont || legacy.font || 'Koruri-extrabold';
    return {
      font:font,
      fontFamily:owns(previewFonts, font) ? previewFonts[font] : null,
      color:field.previewColor || (colorOption && colorOption.color) || legacy.color || '',
      textTransform:field.textTransform || legacy.textTransform || '',
      unavailable:!owns(previewFonts, font) || previewFonts[font] === null
    };
  }

  function wrapText(field, value) {
    if (!field.maxCharsPerLine) return value;
    if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return null;
    var segmenter = new Intl.Segmenter(undefined, { granularity:'grapheme' });
    var parts = value.split(/(\r\n|\r|\n)/);
    for (var partIndex = 0; partIndex < parts.length; partIndex += 2) {
      var line = parts[partIndex];
      if (line === '') continue;
      var wrapped = [];
      var current = '';
      var used = 0;
      (line.match(/(\s+|\S+)/gu) || ['']).forEach(function (token) {
        var glyphs = Array.from(segmenter.segment(token), function (item) { return item.segment; });
        if (used && used + glyphs.length > field.maxCharsPerLine) { wrapped.push(current); current = ''; used = 0; }
        while (glyphs.length > field.maxCharsPerLine - used) {
          var take = field.maxCharsPerLine - used;
          current += glyphs.splice(0, take).join('');
          wrapped.push(current); current = ''; used = 0;
        }
        current += glyphs.join('');
        used += glyphs.length;
      });
      if (used) wrapped.push(current);
      parts[partIndex] = wrapped.join('\n');
    }
    // Preserve explicit CRLF/CR and all whitespace; only newly inserted wraps use LF.
    return parts.join('');
  }

  function normalizeValues(schemaValue, values) {
    var input = values && typeof values === 'object' ? values : {};
    var normalized = Object.assign(Object.create(null), input);
    if (!schemaValue || !Array.isArray(schemaValue.fields)) return normalized;
    schemaValue.fields.forEach(function (field) {
      if (field.kind !== 'text' || !owns(input, field.id) || typeof input[field.id] !== 'string') return;
      var value = input[field.id];
      if (previewStyle(schemaValue, field, input).textTransform === 'uppercase') value = value.toUpperCase();
      var wrapped = wrapText(field, value);
      normalized[field.id] = wrapped === null ? value : wrapped;
    });
    return normalized;
  }

  function textMetrics(field, value) {
    var measured = field.multiline ? value.replace(/\r\n?/g, '\n') : value;
    var lines = measured.split('\n');
    if (field.lengthUnit !== 'grapheme') return { length:measured.length, lines:lines.length };
    if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return null;
    var segmenter = new Intl.Segmenter(undefined, { granularity:'grapheme' });
    var count = function (text) { return Array.from(segmenter.segment(text)).length; };
    var length = lines.reduce(function (total, line) { return total + count(line); }, 0);
    var wrapped = wrapText(field, measured);
    return wrapped === null ? null : { length:length, lines:wrapped.split('\n').length };
  }

  function isBlank(value) {
    // Inspect for a visible value without changing the user's stored spelling.
    return typeof value !== 'string' ||
      value.replace(/[\p{White_Space}\p{Default_Ignorable_Code_Point}\p{Cf}]/gu, '') === '';
  }

  function storedImageUrl(value) {
    if (typeof value !== 'string' || !/^https:\/\//i.test(value) || /[\s\p{Cf}]/u.test(value)) {
      return false;
    }
    try {
      var parsed = new URL(value);
      return parsed.protocol === 'https:' && Boolean(parsed.hostname) &&
        parsed.username === '' && parsed.password === '';
    } catch (error) {
      return false;
    }
  }

  function validateFile(field, value, inCart) {
    var errors = [];
    function add(code) { errors.push({ fieldId: field.id, code: code }); }

    if (value == null || value === '' || (typeof value === 'string' && isBlank(value))) {
      if (field.required) add('required');
      return errors;
    }
    if (inCart) {
      // A previously uploaded file is a URL string, not an empty local File.
      if (!storedImageUrl(value)) add('file_type');
      return errors;
    }
    if (typeof value !== 'object' || isBlank(value.name)) {
      add('file_type');
      return errors;
    }
    if (typeof value.type !== 'string' || !/^image\/[a-z0-9.+-]+$/i.test(value.type)) {
      add('file_type');
    }
    if (typeof value.size !== 'number' || !Number.isFinite(value.size) ||
        value.size <= 0 || value.size > MAX_FILE_BYTES) {
      add('file_size');
    }
    return errors;
  }

  function validate(schemaValue, values, inCart) {
    if (schemaValue && schemaValue.invalid) return [{ fieldId: null, code: 'configuration' }];
    if (!schemaValue || !Array.isArray(schemaValue.fields)) return [];
    var original = values && typeof values === 'object' ? values : {};
    var input = normalizeValues(schemaValue, original);
    var errors = [];
    schemaValue.fields.forEach(function (field) {
      var value = owns(input, field.id) ? input[field.id] : undefined;
      if (field.kind === 'text' && schemaValue.preview && previewStyle(schemaValue, field, input).unavailable) {
        errors.push({ fieldId:field.id, code:'configuration' });
      }
      if (field.kind === 'file') {
        errors = errors.concat(validateFile(field, value, inCart));
        return;
      }
      if (isBlank(value)) {
        if (field.required) errors.push({ fieldId: field.id, code: 'required' });
        return;
      }
      if (inCart && field.kind === 'text' && value !== original[field.id]) {
        errors.push({ fieldId:field.id, code:'normalization' });
      }
      var metrics = textMetrics(field, value);
      if (!metrics) { errors.push({ fieldId:field.id, code:'configuration' }); return; }
      if (typeof field.maxLength === 'number' && metrics.length > field.maxLength) {
        errors.push({ fieldId: field.id, code: 'too_long' });
      }
      if (field.multiline && metrics.lines > field.maxLines) {
        errors.push({ fieldId: field.id, code: field.maxCharsPerLine ? 'too_many_wrapped_lines' : 'too_many_lines' });
      }
      if (field.kind === 'select' && !(field.options || []).some(function (option) {
        return value === option.value;
      })) {
        errors.push({ fieldId: field.id, code: 'choice' });
      }
    });
    return errors;
  }

  // Validate normalized values without mutating the caller; submission applies normalizeValues.
  function validateValues(schemaValue, values) {
    return validate(schemaValue, values, false);
  }

  function validateCartLine(line) {
    if (!line || typeof line !== 'object') return [];
    var schemaValue = getSchema(line.product_id, line.personalization);
    if (!schemaValue) return [];
    var properties = line.properties && typeof line.properties === 'object' ? line.properties : {};
    var values = Object.create(null);
    schemaValue.fields.forEach(function (field) {
      if (owns(properties, field.key)) values[field.id] = properties[field.key];
    });
    // Legacy valid properties do not need a new version marker.
    return validate(schemaValue, values, true);
  }

  function cartIssues(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    var issues = [];
    cart.items.forEach(function (line, index) {
      var errors = validateCartLine(line);
      if (!errors.length) return;
      issues.push({
        lineKey: typeof line.key === 'string' ? line.key : 'line:' + (index + 1),
        title: typeof line.product_title === 'string' ? line.product_title :
          (typeof line.title === 'string' ? line.title : ''),
        productId: productId(line.product_id),
        url: typeof line.url === 'string' ? line.url : '',
        errors: errors
      });
    });
    return issues;
  }

  return Object.freeze({
    products: products,
    productIds: productIds,
    previewFonts: previewFonts,
    legacyPreviewDefaults: legacyPreviewDefaults,
    legacyFieldPatches: legacyFieldPatches,
    previewStyle: previewStyle,
    getSchema: getSchema,
    invalidSchema: invalidSchema,
    wrapText: wrapText,
    normalizeValues: normalizeValues,
    textMetrics: textMetrics,
    validateValues: validateValues,
    validateCartLine: validateCartLine,
    cartIssues: cartIssues
  });
});

(function () {
  'use strict';
  const core = window.ABPersonalizerCore;
  const dictionary = JSON.parse(document.querySelector('[data-ab-i18n]').textContent);
  const t = key => Object.prototype.hasOwnProperty.call(dictionary, key) && typeof dictionary[key] === 'string' ? dictionary[key] : key;
  let sequence = 0;
  let scopeChannel;
  try {
    scopeChannel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('angelbaby-gift-personalizer-scope') : null;
    if (scopeChannel) scopeChannel.addEventListener('message', event => {
      if (event.data === 'gift-cart-changed') resetCartGates();
    });
  } catch (error) { scopeChannel = null; }
  function notifyCartChange() {
    if (scopeChannel) scopeChannel.postMessage('gift-cart-changed');
  }
  function element(tag, attributes, text) {
    const node = document.createElement(tag);
    Object.entries(attributes || {}).forEach(([key, value]) => node.setAttribute(key, value));
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function focusError(node) {
    node.focus({ preventScroll: true });
    node.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  class Personalizer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.schema) {
        try {
          this.schema = core.getSchema(this.dataset.productId, this.hasAttribute('data-ab-config') ? JSON.parse(this.dataset.abConfig) : undefined);
        } catch (error) { this.schema = core.invalidSchema(this.dataset.productId); }
      }
      if (!this.schema) return;
      this.ready = true;
      this.controls = Object.create(null);
      this.errors = Object.create(null);
      this.replaceChildren();
      this.append(element('h3', { class: 'ab-title' }, t('heading')));
      this.append(element('p', { class: 'ab-help' }, t('intro')));
      this.summary = element('p', { class: 'ab-summary', role: 'alert', hidden: '' });
      this.append(this.summary);
      if (this.schema.invalid) {
        this.summary.hidden = false;
        this.summary.tabIndex = -1;
        this.summary.textContent = t('error_configuration');
        return;
      }
      this.schema.fields.forEach(field => {
        const id = 'ab-' + (++sequence) + '-' + field.id;
        const group = element('div', { class: 'ab-field' });
        const label = element('label', { for: id }, t(field.label));
        if (field.required) label.append(element('span', { class: 'ab-required' }, t('required_badge')));
        const inputTag = field.kind === 'select' ? 'select' : field.kind === 'text' && field.multiline ? 'textarea' : 'input';
        const input = element(inputTag, {
          id, name: 'properties[' + field.key + ']', 'aria-describedby': id + '-error',
          'data-ab-field': field.id, class: 'ab-control'
        });
        if (field.required) input.required = true;
        if (field.kind === 'select') {
          input.append(element('option', { value: '' }, t('choose')));
          field.options.forEach(option => input.append(element('option', { value: option.value }, t(option.label))));
        } else {
          if (field.kind === 'file') { input.type = 'file'; input.accept = 'image/*'; }
          else {
            if (field.multiline) input.rows = field.maxLines;
            else input.type = 'text';
            if (field.lengthUnit !== 'grapheme') input.maxLength = field.maxLength;
            input.placeholder = field.placeholder;
            input.autocomplete = 'off';
            input.setAttribute('autocapitalize', 'off');
            input.spellcheck = false;
          }
        }
        const error = element('p', { id: id + '-error', class: 'ab-error', hidden: '' });
        group.append(label, input);
        if (field.multiline) {
          const help = element('p', {id:id + '-help', class:'ab-help'}, t(field.maxCharsPerLine ? 'wrapped_help' : 'multiline_help').replace('{lines}', String(field.maxLines)).replace('{max}', String(field.maxLength)).replace('{perLine}', String(field.maxCharsPerLine)));
          input.setAttribute('aria-describedby', id + '-help ' + id + '-error');
          group.append(help);
        }
        group.append(error);
        this.append(group);
        this.controls[field.id] = input;
        this.errors[field.id] = error;
        ['input', 'change'].forEach(event => input.addEventListener(event, () => this.update()));
        input.addEventListener('blur', () => {
          if (this.attempted) this.update();
        });
      });
      if (this.schema.preview) {
        this.preview = element('div', { class: 'ab-preview' });
        this.preview.append(element('span', { class: 'ab-help' }, t('preview')));
        this.previewText = element('div', { class: 'ab-preview-text' });
        this.preview.append(this.previewText, element('p', { class: 'ab-help' }, t('preview_note')));
        this.append(this.preview);
      }
      this.update();
      const ownerForm = this.closest('form');
      if (ownerForm) ownerForm.addEventListener('formdata', event => {
        if (!this.isConnected || this.closest('form') !== ownerForm) return;
        const normalized = core.normalizeValues(this.schema, this.values());
        this.schema.fields.filter(field => field.kind === 'text').forEach(field => event.formData.set('properties[' + field.key + ']', normalized[field.id]));
      });
      const submit = this.closest('form') && this.closest('form').querySelector('[data-ab-submit]');
      if (submit && submit.dataset.abUnavailable === 'false') submit.disabled = false;
    }
    disconnectedCallback() {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    }
    values() {
      return Object.fromEntries(this.schema.fields.map(field => [field.id,
        field.kind === 'file' ? this.controls[field.id].files[0] : this.controls[field.id].value]));
    }
    setProperties(properties) {
      this.schema.fields.forEach(field => {
        if (field.kind !== 'file') this.controls[field.id].value = Object.prototype.hasOwnProperty.call(properties, field.key) && typeof properties[field.key] === 'string' ? properties[field.key] : '';
      });
      this.update();
    }
    update() {
      const values = core.normalizeValues(this.schema, this.values());
      const errors = core.validateValues(this.schema, values);
      const imageField = this.schema.fields.find(field => field.kind === 'file');
      const imageValue = imageField && values[imageField.id];
      if (imageField && this.previewFile !== imageValue) {
        this.previewFile = imageValue;
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        if (this.imagePreview) this.imagePreview.remove();
        if (imageValue && !errors.some(error => error.fieldId === imageField.id)) {
          this.objectUrl = URL.createObjectURL(imageValue);
          this.imagePreview = element('img', { src: this.objectUrl, alt: t('image_preview'), class: 'ab-image-preview' });
          this.append(this.imagePreview);
        }
      }
      if (this.attempted) this.showErrors(errors);
      this.schema.fields.filter(field => field.kind === 'text').forEach(field => {
        this.controls[field.id].style.textTransform = core.previewStyle(this.schema, field, values).textTransform;
      });
      if (this.previewText) {
        const textFields = this.schema.fields.filter(field => field.kind === 'text');
        const parentStyle = core.previewStyle(this.schema, textFields[0], values);
        this.previewText.style.fontFamily = parentStyle.fontFamily || '';
        this.previewText.style.color = parentStyle.color;
        this.previewText.replaceChildren();
        textFields.filter(field => values[field.id]).forEach(field => {
          if (this.previewText.childNodes.length) this.previewText.append(document.createTextNode('\n'));
          const style = core.previewStyle(this.schema, field, values);
          const line = element('span', { 'data-ab-preview-field':field.id }, style.unavailable ? t('error_configuration') : values[field.id]);
          line.style.fontFamily = style.fontFamily || '';
          line.style.color = style.color;
          line.style.textTransform = style.textTransform;
          this.previewText.append(line);
        });
        if (!this.previewText.childNodes.length) this.previewText.textContent = t('preview_empty');
      }
      const scope = this.closest('product-info') || this.closest('.shopify-section') || this.closest('form');
      if (scope && !this.closest('dialog')) {
        scope.querySelectorAll('[data-ab-product-gate]').forEach(gate => {
          gate.inert = errors.length > 0;
          gate.hidden = errors.length > 0;
          const prompt = gate.previousElementSibling;
          if (prompt && prompt.matches('[data-ab-gate-prompt]')) prompt.hidden = errors.length === 0;
        });
      }
      return errors;
    }
    showErrors(errors) {
      Object.keys(this.controls).forEach(id => {
        const error = errors.find(item => item.fieldId === id);
        this.controls[id].setAttribute('aria-invalid', error ? 'true' : 'false');
        this.errors[id].hidden = !error;
        const requiredKind = this.controls[id].tagName === 'SELECT' || this.controls[id].type === 'file' ? 'select' : 'text';
        const messageKey = error && error.code === 'required' && dictionary['error_required_' + requiredKind]
          ? 'error_required_' + requiredKind : error ? 'error_' + error.code : '';
        const field = this.schema.fields.find(item => item.id === id);
        this.errors[id].textContent = error ? t(messageKey).replace('{field}', t(field.label)).replace('{max}', String(field.maxLength)).replace('{lines}', String(field.maxLines)).replace('{perLine}', String(field.maxCharsPerLine)) : '';
      });
      this.summary.hidden = errors.length === 0;
      const summaryText = errors.length ? t('attention') : '';
      if (this.summary.textContent !== summaryText) this.summary.textContent = summaryText;
    }
    normalizeControls() {
      const normalized = core.normalizeValues(this.schema, this.values());
      this.schema.fields.filter(field => field.kind === 'text').forEach(field => { this.controls[field.id].value = normalized[field.id]; });
    }
    validate() {
      if (this.schema.invalid) { focusError(this.summary); return false; }
      this.attempted = true;
      const errors = this.update();
      if (errors.length) focusError(this.controls[errors[0].fieldId]);
      else this.normalizeControls();
      return errors.length === 0;
    }
  }
  customElements.define('ab-personalizer', Personalizer);
  function validateProductForm(form) {
    if (form.dataset.abGiftBusy === 'true') return false;
    const personalizer = form.querySelector('ab-personalizer');
    if (!personalizer) return true;
    if (!personalizer.ready) return false;
    return personalizer.validate();
  }
  window.ABPersonalizerUI = { validateProductForm };
  document.addEventListener('click', event => {
    const gate = event.target.closest('[data-ab-product-gate]');
    const scope = gate && (gate.closest('product-info') || gate.closest('.shopify-section') || gate.closest('form'));
    const personalizer = scope && scope.querySelector('ab-personalizer');
    if (personalizer && !personalizer.validate()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    const prompt = event.target.closest('[data-ab-gate-prompt]');
    if (!prompt) return;
    event.preventDefault();
    const scope = prompt.closest('product-info') || prompt.closest('.shopify-section');
    const personalizer = scope && scope.querySelector('ab-personalizer');
    if (personalizer) personalizer.validate();
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]') && !validateProductForm(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  let checkoutBusy = false;
  let cartRevision = 0;
  let giftVerification = 0;
  let repairDialog;
  const rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  async function cartRequest(path, options) {
    const response = await fetch(rootPath + path, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('cart_request_failed');
    return response.json();
  }
  function assertCartQuantitiesSaved() {
    const quantities = document.querySelectorAll(
      'cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"], form[action$="/cart"] input[name="updates[]"]'
    );
    if (document.querySelector('.cart__items--disabled') ||
        Array.from(quantities).some(input => input.value !== input.getAttribute('value'))) {
      throw new Error('cart_updating');
    }
  }
  async function latestCart() {
    assertCartQuantitiesSaved();
    const section = 'ab-personalizer-config';
    const rendered = await cartRequest('cart?sections=' + section + '&ab_request=' + Date.now());
    if (!rendered || typeof rendered[section] !== 'string') throw new Error('configuration_missing');
    const documentValue = new DOMParser().parseFromString(rendered[section], 'text/html');
    const snapshots = documentValue.querySelectorAll('[data-ab-cart-config]');
    if (snapshots.length !== 1) throw new Error('configuration_missing');
    const cart = JSON.parse(snapshots[0].getAttribute('data-ab-cart-config'));
    if (!cart || cart.version !== 1 || !Array.isArray(cart.items)) throw new Error('configuration_invalid');
    if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('configuration_incomplete');
    const keys = new Set();
    let itemCount = 0;
    for (const line of cart.items) {
      if (!line || typeof line.key !== 'string' || !line.key || keys.has(line.key) ||
          !/^[0-9]+$/.test(String(line.product_id)) || !Number.isInteger(line.quantity) || line.quantity < 1 ||
          !Object.prototype.hasOwnProperty.call(line, 'personalization') ||
          !line.properties || typeof line.properties !== 'object' || Array.isArray(line.properties) ||
          !Number.isInteger(line.property_count) || Object.keys(line.properties).length !== line.property_count) throw new Error('configuration_invalid');
      keys.add(line.key);
      itemCount += line.quantity;
    }
    if (itemCount !== cart.item_count) throw new Error('configuration_incomplete');
    assertCartQuantitiesSaved();
    return cart;
  }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-ab-gift-cart]');
    if (!trigger) return;
    event.preventDefault();
    const scope = trigger.closest('product-info') || trigger.closest('.shopify-section');
    const personalizer = scope && scope.querySelector('ab-personalizer');
    const form = personalizer && personalizer.closest('form');
    if (!form || form.dataset.abGiftBusy === 'true') return;
    const status = trigger.parentElement.querySelector('[data-ab-gift-status]');
    const submit = form.querySelector('button[name="add"]');
    if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) {
      status.textContent = t('unavailable');
      return;
    }
    if (!validateProductForm(form)) return;
    form.dataset.abGiftBusy = 'true';
    trigger.disabled = true;
    status.textContent = t('saving');
    try {
      await cartRequest('cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      notifyCartChange();
      window.location.assign(rootPath + 'cart#personalization-gift');
    } catch (error) {
      status.textContent = t('add_error');
      form.dataset.abGiftBusy = 'false';
      trigger.disabled = false;
    }
  });
  function closeRepair() {
    if (repairDialog) { repairDialog.close(); repairDialog.remove(); repairDialog = null; }
  }
  function showRepair(cart, issues) {
    closeRepair();
    repairDialog = element('dialog', { class: 'ab-cart-dialog', 'aria-labelledby': 'ab-cart-title' });
    const close = element('button', { type: 'button', class: 'ab-close' }, t('close'));
    close.addEventListener('click', closeRepair);
    repairDialog.append(close, element('h2', { id: 'ab-cart-title' }, t('cart_heading')),
      element('p', {}, t('cart_intro')));
    const first = issues[0];
    const line = cart.items.find(item => item.key === first.lineKey);
    repairDialog.append(element('h3', {}, line.product_title || line.title));
    const schema = core.getSchema(line.product_id, line.personalization);
    if (!schema || schema.invalid) {
      repairDialog.append(element('p', {role:'alert'}, t('error_configuration')));
    } else if (first.errors.some(error => schema.fields.some(field => field.id === error.fieldId && field.kind === 'file'))) {
      repairDialog.append(element('p', {}, t('cart_file')),
        element('a', { class: 'button', href: rootPath + 'cart' }, t('go_cart')));
    } else {
      const form = element('form', { novalidate: '' });
      const editor = element('ab-personalizer', { 'data-product-id': String(line.product_id) });
      editor.schema = { ...schema, fields:schema.fields.filter(field => field.kind !== 'file') };
      const status = element('p', { role: 'status', class: 'ab-error' });
      const save = element('button', { type: 'submit', class: 'button button--primary' }, t('save_cart'));
      form.append(editor, status, save);
      repairDialog.append(form);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!editor.validate()) return;
        save.disabled = true;
        status.textContent = t('saving');
        try {
          const latest = await latestCart();
          const current = latest.items.find(item => item.key === line.key);
          if (!current || current.quantity !== line.quantity || JSON.stringify(current.properties) !== JSON.stringify(line.properties) || JSON.stringify(core.getSchema(current.product_id, current.personalization)) !== JSON.stringify(schema)) {
            status.textContent = t('cart_changed');
            save.disabled = false;
            return;
          }
          const properties = Object.assign(Object.create(null), current.properties || {});
          const values = editor.values();
          editor.schema.fields.forEach(field => { properties[field.key] = values[field.id]; });
          await cartRequest('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: current.key, quantity: current.quantity, properties }) });
          notifyCartChange();
          window.location.assign(rootPath + 'cart');
        } catch (error) {
          status.textContent = t(error.message === 'cart_updating' ? 'cart_updating' : 'network_error');
          save.disabled = false;
        }
      });
      document.body.append(repairDialog);
      editor.setProperties(line.properties || {});
    }
    if (!repairDialog.isConnected) document.body.append(repairDialog);
    repairDialog.showModal();
    repairDialog.addEventListener('click', event => { if (event.target === repairDialog) closeRepair(); });
  }
  async function guardedCheckout(event, trigger) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    const revision = cartRevision;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const cart = await latestCart();
      if (revision !== cartRevision) throw new Error('cart_changed');
      const issues = core.cartIssues(cart);
      if (issues.length) showRepair(cart, issues);
      else window.location.assign(rootPath + 'checkout');
    } catch (error) {
      let status = document.querySelector('[data-ab-cart-status]');
      if (!status) {
        status = element('p', { 'data-ab-cart-status': '', class: 'ab-error', role: 'alert', tabindex: '-1' });
        trigger.insertAdjacentElement('beforebegin', status);
      }
      status.textContent = t(error.message === 'cart_updating' ? 'cart_updating' : 'network_error');
      focusError(status);
    } finally {
      checkoutBusy = false;
      trigger.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], [data-ab-cart-checkout]');
    if (trigger) guardedCheckout(event, trigger);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('form[action$="/cart"]') && event.submitter && event.submitter.name === 'checkout') {
      guardedCheckout(event, event.submitter);
    }
  }, true);
  function resetCartGates() {
    cartRevision++;
    giftVerification++;
    document.querySelectorAll('[data-ab-cart-gate]').forEach(gate => {
      gate.inert = true;
      gate.hidden = true;
      const prompt = gate.previousElementSibling;
      if (prompt && prompt.matches('[data-ab-cart-reveal]')) prompt.hidden = false;
    });
    document.querySelectorAll('[data-ab-cart-gift-gate]').forEach(gate => {
      gate.inert = true;
      gate.hidden = true;
      const prompt = gate.previousElementSibling;
      if (prompt) prompt.hidden = false;
    });
  }
  async function verifyCartGift(showErrors) {
    const gate = document.querySelector('[data-ab-cart-gift-gate]');
    if (!document.querySelector('.sns-gift-new-cart-container')) return false;
    const verification = ++giftVerification;
    const revision = cartRevision;
    const cart = await latestCart();
    if (revision !== cartRevision || verification !== giftVerification) return false;
    const issues = core.cartIssues(cart);
    if (issues.length) {
      if (showErrors) showRepair(cart, issues);
      return false;
    }
    if (gate) {
      gate.hidden = false;
      gate.inert = false;
      const prompt = gate.previousElementSibling;
      if (prompt && prompt.matches('[data-ab-cart-gift-prompt]')) prompt.hidden = true;
    }
    return true;
  }
  const allowedGiftClicks = new WeakSet();
  const allowedGiftSubmissions = new WeakSet();
  function isGiftForm(form) {
    return form instanceof HTMLFormElement && Boolean(form.closest('.sns-gift-new-cart-container'));
  }
  async function guardedGift(event, trigger, form, action) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const owner = form || trigger;
    if (owner.dataset.abChecking === 'true') return;
    owner.dataset.abChecking = 'true';
    try {
      if (await verifyCartGift(true)) {
        if (!trigger.isConnected || trigger.disabled || (form && !form.isConnected)) return;
        if (action !== 'prompt') {
          if (form) allowedGiftSubmissions.add(form);
          if (action === 'click') allowedGiftClicks.add(trigger);
          try {
            if (action === 'submit') form.requestSubmit(trigger === form ? undefined : trigger);
            else trigger.click();
          } finally {
            allowedGiftClicks.delete(trigger);
            if (form) allowedGiftSubmissions.delete(form);
          }
        }
      }
    } catch (error) {
      let status = document.querySelector('[data-ab-cart-gift-status]');
      if (!status) {
        const widget = document.querySelector('.sns-gift-new-cart-container');
        if (widget) {
          status = element('p', { 'data-ab-cart-gift-status': '', class: 'ab-error', role: 'alert' });
          widget.insertAdjacentElement('afterend', status);
        }
      }
      if (status) status.textContent = t(error.message === 'cart_updating' ? 'cart_updating' : 'network_error');
    } finally { delete owner.dataset.abChecking; }
  }
  document.addEventListener('click', event => {
    const candidate = event.target.closest('button, input[type="submit"]');
    const checkout = candidate && (candidate.id === 'all-in-gift-checkout-button' ||
      (candidate.type === 'submit' && isGiftForm(candidate.form))) ? candidate : null;
    const prompt = event.target.closest('[data-ab-cart-gift-prompt]');
    if ((!checkout && !prompt) || !document.querySelector('.sns-gift-new-cart-container')) return;
    if (checkout && allowedGiftClicks.has(checkout)) { allowedGiftClicks.delete(checkout); return; }
    const form = checkout && isGiftForm(checkout.form) ? checkout.form : null;
    guardedGift(event, checkout || prompt, form, checkout ? 'click' : 'prompt');
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!isGiftForm(form)) return;
    if (allowedGiftSubmissions.has(form)) { allowedGiftSubmissions.delete(form); return; }
    guardedGift(event, event.submitter || form, form, 'submit');
  }, true);
  document.addEventListener('click', async event => {
    const prompt = event.target.closest('[data-ab-cart-reveal]');
    if (!prompt) return;
    event.preventDefault();
    if (prompt.disabled) return;
    prompt.disabled = true;
    const revision = cartRevision;
    try {
      const cart = await latestCart();
      if (revision !== cartRevision) return;
      const issues = core.cartIssues(cart);
      if (issues.length) showRepair(cart, issues);
      else {
        const gate = prompt.nextElementSibling;
        gate.hidden = false;
        gate.inert = false;
        prompt.hidden = true;
      }
    } catch (error) {
      prompt.textContent = t(error.message === 'cart_updating' ? 'cart_updating' : 'network_error');
    } finally { prompt.disabled = false; }
  });
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items, cart-drawer, form[action$="/cart"]')) resetCartGates();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) resetCartGates(); });
  window.addEventListener('pageshow', () => {
    resetCartGates();
    if (document.querySelector('[data-ab-cart-gift-gate]')) verifyCartGift(false).catch(() => {});
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      const buttonId = 'ProductSubmitButton-' + data.sectionId;
      const sourceButton = data.html.getElementById(buttonId);
      const button = document.getElementById(buttonId);
      const form = button && button.closest('form');
      const personalizer = form && form.querySelector('ab-personalizer');
      if (!personalizer || !sourceButton || !sourceButton.hasAttribute('data-ab-unavailable')) return;
      const unavailable = !data.variant || sourceButton.dataset.abUnavailable !== 'false';
      button.dataset.abUnavailable = String(unavailable);
      const blocked = Boolean(unavailable || !personalizer.ready || personalizer.schema.invalid);
      const productForm = form.closest('product-form');
      if (productForm && typeof productForm.toggleSubmitButton === 'function') productForm.toggleSubmitButton(blocked);
      else button.disabled = blocked;
      if (personalizer.ready && !personalizer.schema.invalid) personalizer.update();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      notifyCartChange();
      resetCartGates();
    });
  }
  if (document.querySelector('[data-ab-cart-gift-gate]')) {
    verifyCartGift(false).catch(() => {});
  }
})();
  } catch(e) { console.error(e); }
})();

})();
